<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-bookmark-check</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;CHEKIN&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template>        
       
      </template> -->
    </v-toolbar>
   
  </div>
</template>
<script>
  import api from '@/services/api'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
    },
    mounted () {
      if (this.content.isNew) this.handleChangeIsModified()
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      },
    }
  }
</script>

<style scoped>
</style>

